import { status } from 'constants/general';

export const initialCommonState = {
  context: '',
  staticData: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
  companyProfilesList: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
  selectedCompanyProfile: {},
};

export const initialGeneralState = {
  testGeneral: '',
};

export const initialPostsState = {
  postsList: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
  addOrEditPost: {
    status: status.SHOULD_CALL_API,
  },
  deletePost: {
    status: status.SHOULD_CALL_API,
  },
  postDetails: {},
  rssFeedList: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
  addRssFeed: {
    status: status.SHOULD_CALL_API,
  },
  editRssFeed: {
    status: status.SHOULD_CALL_API,
  },
};

export const initialDoctorsState = {
  doctorsList: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
  updateDoctorLicenceStatus: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
  assignOrRevokeDoctorBadges: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
};

export const initialCompanyActivationState = {
  companyActivationList: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
  updateCompanyLicenceStatus: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
};

export const initialCirclesState = {
  closedCirclesList: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
  changeClosedCircleStatus: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
};

export const initialCompaniesState = {
  addOrEditCompany: {
    status: status.SHOULD_CALL_API,
  },
};

export const initialProfilesState = {
  profileDetails: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
  updateProfileInfo: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
};

export const initialAccountManagementState = {};
